export const OTP_PHASE = {
  ENROLLMENT: 'enrollment',
  VERIFICATION: 'verification',
  BACKUP: 'backup',
  BYPASS: 'bypass',
  SEND_FAILED: 'send-failed'
};

export const getOtpRoute = (phase) => {
  switch (phase) {
    case OTP_PHASE.ENROLLMENT:
      return '/auth/otp-setup';
    case OTP_PHASE.BACKUP:
      return '/auth/otp-backup';
    case OTP_PHASE.BYPASS:
      return '/auth/otp-bypass';
    case OTP_PHASE.SEND_FAILED:
      return '/auth/otp-send-failed';
    default:
      return '/auth/otp';
  }
};
